import request from '@/infra/request';
// 衍生工具管理模块API


//============================成交单管理================================
/**
 * 成交单导入列表查询
 */
export function getTransactionOrderImportList(params) {
    return request.get('/api/T_InstrumentLocal/list', { params });
}

export function addBatch(params) {
    return request.post('/api/T_InstrumentTrade/addbatch', params);
}

export function addBatchExchange(params) {
    return request.post('/api/T_InstrumentExchange/addbatch', params);
}

/**
 * 成交单-逐笔增加
 */
export function addTransactionOrderOneByOne(params) {
    return request.post('/api/T_InstrumentLocal/addone', params);
}
/**
 * 成交单-批量导入
 */
export function imporyTransactionOrderByGroup(params) {
    return request.post('/api/T_InstrumentLocal/addone', params);
}
/**
 * 成交单-删除
 */
export function deleteTransactionOrder(params) {
    return request.post('/api/T_InstrumentLocal/delete', params);
}

/**
 * 成交单-更新
 */
export function updateTransactionOrder(params) {
    return request.post('/api/T_InstrumentLocal/update', params);
}


//============================成交对账================================
/**
 * 成交对账列表查询
 */
export function getTransactionOrderReconciliationList(params) {
    return request.get('/api/T_InstrumentExchange/list', { params });
}

/**
 * 交易对账数据-逐笔增加
 */
export function addTransactionOrderReconciliationOneByOne(params) {
    return request.post('/api/T_InstrumentExchange/addone', params);
}

/**
 * 交易对账数据-删除
 */
export function deleteTransactionOrderReconciliation(params) {
    return request.post('/api/T_InstrumentExchange/delete',params);
}
/**
 * 交易对账数据-更新
 */
export function updateTransactionOrderReconciliation(params) {
    return request.post('/api/T_InstrumentExchange/Update',params);
}
//============================成交单管理================================

/**
 * 成交单管理-列表查询
 */
export function getTransactionOrderMgtList(params) {
    return request.get('/api/T_InstrumentLocal/CheckHedgingTrade', { params });
}

/**
 * 成交单管理-上次结算日期查询
 */
export function getLastSettlementTime(params) {
    return request.get('/api/T_Settlement/Query_SettlmentCalendar', { params });
}
/**
 * 成交单管理-指令执行情况汇总
 */
export function getExecutionSummary(params) {
    return request.get('/api/t_reportingservice/QueryReport_HedgingTask', { params });
}

/**
 * 成交单管理-结算
 */
export function sendSettlement(params) {
    return request.post('/api/T_Settlement/Settlement', params);
}
/**
 * 成交单管理-结算日志查询
 */
export function getSettlementLogList(params) {
    return request.get('/api/T_Settlement_Log/list', { params });
}

/**
 * 成交单管理-结算价列表查询
 */
export function getSettlementPriceList(params) {
    return request.get('/api/T_Settlement_Price/list', { params });
}
/**
 * 成交单管理-结算价新增
 */
export function addSettlementPrice(params) {
    return request.post('/api/T_Settlement_Price/add', params);
}

/**
 * 成交单管理-结算价编辑
 */
export function updateSettlementPrice(params) {
    return request.post('/api/T_Settlement_Price/edit', params);
}

/**
 * 成交单管理-历史结算
 */
export function historySettlement(params) {
    return request.post('/api/T_Settlement/HisSettlementInput', params);
}


/**
 * 成交单管理-获取结算日期
 */
export function getSettlementDay(params) {
    return request.get('/api/T_Trading_Status/BusiDate', { params });
}
/**
 * 成交单管理-合约查询
 */
export function getContract(params) {
    return request.get('/api/T_Instrument/GetCommodityContract2', { params });
}


/**
 * 成交单管理-批量导入结算价
 */
export function importSettlementPrice(params) {
    return request.post('/api/T_Settlement_Price/BatchAdd', params);
}

/**
 * 成交单管理-成交管理-查询上次对账日期
 */
export function getLastReconciliationDay(params) {
    return request.get('/api/T_InstrumentTrade/Query_CheckInstrumentCalendar', {params});
}

/**
 * 成交单管理-成交管理-对账
 */
export function transactionReconciliation(params) {
    return request.post('/api/T_InstrumentTrade/CheckInstrument', params);
}

/**
 * 成交单管理-成交管理-交易所对账数据列表
 */
export function reconciliationList(params) {
    return request.get('/api/T_InstrumentExchange/list', {params});
}
/**
 * 成交单管理-成交管理-交易所对账数据导入
 */
export function reconciliationImport(params) {
    return request.post('/api/T_InstrumentExchange/addbatch', params);
}

/**
 * 成交单管理-成交管理-交易所对账数据新增
 */
export function reconciliationAdd(params) {
    return request.post('/api/T_InstrumentExchange/Add',params);
}

/**
 * 成交单管理-成交管理-交易所对账数据编辑
 */
export function reconciliationUpdate(params) {
    return request.post('/api/T_InstrumentExchange/Update',params);
}

/**
 * 成交单管理-成交管理-交易所对账数据删除
 */
export function reconciliationDelete(params) {
    return request.post('/api/T_InstrumentExchange/delete', params);
}

/**
 * 成交单管理-成交管理-本地成交单列表
 */
export function localTransactionList(params) {
    return request.get('/api/T_InstrumentTrade/list', {params});
}

/**
 * 成交单管理-成交管理-本地成交单导入
 */
export function localTransactionImport(params) {
    return request.post('/api/T_InstrumentTrade/addbatch', params);
}


/**
 * 成交单管理-成交管理-本地成交单新增
 */
export function localTransactionAdd(params) {
    return request.post('/api/T_InstrumentTrade/add', params);
}

/**
 * 成交单管理-成交管理-本地成交单更新
 */
export function localTransactionUpdate(params) {
    return request.post('/api/T_InstrumentTrade/update', params);
}

/**
 * 成交单管理-成交管理-本地成交单删除
 */
export function localTransactionDelete(params) {
    return request.post('/api/T_InstrumentTrade/delete', params);
}
//============================套保委托指令================================
/**
 * 获取委托指令明细列表
 */
export function getMandateInstructionsDetailList(params) {
    return request.get('/api/T_Hedging_Tasks/list',{params});
}

/**
 * 获取资金账户选择项
 */
export function getTransactionOrderFundAccountList(params) {
    return request.get('/api/T_Org_Relationship_Accounting/GetTradingAccountID',{params});
}


/**
 * 获取资金账户选择项
 */
export function getTransactionOrderInstrumentCodeList(params) {
    return request.get('/api/T_Org_Relationship_Accounting/GetInstrumentCode',{params});
}

export function getInstrumentCodes(params) {
    return request.get('/api/T_Org_Relationship_Accounting/GetInstrumentCode',{params});
}


/**
 * 获取合约选项
 */
export function getContractOptions(params) {
    return request.get('/api/T_Instrument/GetCommodityContract2',{params});
}

export function unincludedList(params) {
    return request.get('/api/T_Hedging_Strategy/UnincludedList',{params});
}

export function strategyDetailsList(params) {
    return request.get('/api/T_Hedging_Strategy/DetailsList',{params});
}

export function updateDetails(params) {
    return request.post('/api/T_Hedging_Strategy/UpdateDetails', params);
}

export function settlementExport(params) {
    return request.get('/api/T_Settlement_Price/Export',{params});
}
